import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface DateRangeValidatorOptions {
  startKey?: string;
  endKey?: string;
  ongoingKey?: string;
}

/**
 * Cross-field validator that flags `endDate < startDate` on a FormGroup.
 * Skips when either field is empty or when the ongoing-flag (e.g. isCurrentlyStudying) is true.
 */
export function dateRangeValidator(options: DateRangeValidatorOptions = {}): ValidatorFn {
  const startKey = options.startKey ?? 'startDate';
  const endKey = options.endKey ?? 'endDate';
  const ongoingKey = options.ongoingKey;

  return (group: AbstractControl): ValidationErrors | null => {
    const start = group.get(startKey)?.value;
    const end = group.get(endKey)?.value;
    const ongoing = ongoingKey ? group.get(ongoingKey)?.value : false;

    if (ongoing || !start || !end) {
      return null;
    }
    return new Date(end) < new Date(start) ? { dateRange: true } : null;
  };
}
